import { type PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { IS_PRODUCTION } from '@/shared/constants/env';
import { THIS_IS_DEFAULT_STATIC_OR_SERVER_SIDE_PROPS } from '@/utils/next';
import { type MetaProps } from './Meta';

/**
 * 데이터 페칭 없이(= 정적 셸) 도는 페이지. 번역은 `StaticShellGate` 가 클라에서 채우므로
 * `getDefaultStaticProps` 마커가 없는 게 정상이다. 새 페이지를 정적 셸로 바꾸면 여기에 추가한다.
 */
const CLIENT_SHELL_PATHNAMES: RegExp[] = [/^\/board\/\[boardId\]/];
const WHITE_LIST: RegExp[] = [/^\/admin/, ...CLIENT_SHELL_PATHNAMES];
export const RequireDefaultPageProps = (props: PropsWithChildren<Pick<MetaProps, 'pageProps'>>) => {
  const {
    pathname
  } = useRouter();
  const noDefaultStaticOrServerSideProps = props.pageProps[THIS_IS_DEFAULT_STATIC_OR_SERVER_SIDE_PROPS] !== true;
  const isNotWhiteList = !WHITE_LIST.some(regex => regex.test(pathname));
  if (IS_PRODUCTION) {
    return props.children;
  }
  if (noDefaultStaticOrServerSideProps && isNotWhiteList) {
    throw new Error('페이지 컴포넌트에 GetDefaultStaticProps 또는 GetDefaultServerSideProps를 사용하세요!');
  }
  return props.children;
};